import * as React from "react";
import { GatsbySeo } from "gatsby-plugin-next-seo";
import { useI18next } from "gatsby-plugin-react-i18next";
import { useMetadata } from "hooks/useMetadata";

export const Seo = () => {
    const metadata = useMetadata();
    const {
        languages,
        language,
        originalPath,
        defaultLanguage,
        siteUrl = "http://localhost:8000",
    } = useI18next();
    
    // Check if current page is news page and should not be indexed
    const shouldNoIndex = originalPath.includes("/news");
    
    const createUrlWithLang = (lng: string) => {
        const url = `${siteUrl}${
            lng === defaultLanguage ? "" : `/${lng}`
        }${originalPath}`;
        return url.endsWith("/") ? url : `${url}/`;
    };

    return (
        <GatsbySeo
            noindex={shouldNoIndex}
            title={metadata?.title ?? ""}
            description={metadata?.description ?? ""}
            canonical={createUrlWithLang(language)}
            language={language}
            languageAlternates={[
                ...languages.map((lng) => ({
                    hrefLang: lng,
                    href: createUrlWithLang(lng),
                })),
                {
                    hrefLang: "x-default",
                    href: createUrlWithLang(defaultLanguage),
                },
            ]}
            openGraph={{
                type: "game",
                url: createUrlWithLang(language),
                locale: language.replace("-", "_"),
                title: metadata?.title ?? "",
                description: metadata?.description ?? "",
                site_name: metadata?.title ?? "",
                images: [
                    {
                        url: metadata?.image ?? "",
                        width: 1200,
                        height: 630,
                        alt: metadata?.title ?? "",
                    },
                ],
            }}
            twitter={{
                cardType: "summary_large_image",
                site: "@rise_of_eros",
                handle: "@rise_of_eros",
            }}
        />
    );
};
